export default __webpack_public_path__ + "static/media/correct20.cf82bebc.mp3";